export default __webpack_public_path__ + "static/3_9-11dcdf884ae0138fb873ee4938dbc2b6.png";